import {OverlayTransition} from './OverlayTransition';
import {AbstractAnimation} from '../animations/AbstractAnimation';
import {GroupAnimation} from '../animations/GroupAnimation';

export class GroupOverlayTransition extends OverlayTransition {

    public create(...animations:AbstractAnimation[]) {
        this.animation=new GroupAnimation(...animations);
        return this;
    }

}

export {};